import { replace } from 'redux-first-history';
import {
  GROUP_FETCHED,
  GROUP_FETCHED_ERRORED,
  GROUP_FETCHED_INACTIVE,
  GROUP_FETCHING,
} from './';

import { getGroup } from '../api';

const DISABLE_ALT_TIMES_GROUPS = [
  'Xfinity',
  'Spectrum',
  'Rutgers Piscataway - BYOD',
  'Rutgers Newark - BYOD',
  'Rutgers - Camden BYOD',
];
const disableAltTimeMobile = window.screen.width <= 1280;

const disableAltTimeSelection = groupName => {
  return DISABLE_ALT_TIMES_GROUPS.includes(groupName) || disableAltTimeMobile;
};

export default function fetchGroup(id, asSlug = true) {
  return (dispatch, getState) => {
    const {
      repair: { repairState, id: repairID },
    } = getState();
    dispatch({ type: GROUP_FETCHING });

    return getGroup({ id, asSlug })
      .then(group => {
        if (group.account_active) {
          dispatch({
            type: GROUP_FETCHED,
            group: {
              ...group,
              //disable alt times if repair is filed or a repairID exists (meaning we're on the tracking page)
              disableAltTimes:
                ['filed'].includes(repairState) || repairID
                  ? true
                  : disableAltTimeSelection(group.account_name),
            },
            communicationPreference: group.customer_communication_enabled
              ? 'text'
              : 'disable',
          });
        } else {
          dispatch({
            type: GROUP_FETCHED_INACTIVE,
            group: {
              ...group,
            },
          });
          dispatch(replace(`/inactive/${group.slug}`));
        }
      })
      .catch(err => {
        console.warn(err);
        dispatch({ type: GROUP_FETCHED_ERRORED });
        dispatch(replace(`/${id}`));
      });
  };
}
